import { select } from '@js/util/select.js'
import Swiper, { Pagination, Autoplay } from 'swiper'
Swiper.use([Pagination, Autoplay])

select('.wpce-testimonial', testimonialElement => {
  if (!testimonialElement.dataset.swiperId) return

  const options = {
    direction: 'horizontal',
    loop: false,
    threshold: 10,
    spaceBetween: 20,
    centeredSlides: false,
    slidesPerView: 'auto',
    allowTouchMove: false,
    autoplay: false,
    autoHeight: true,
    pagination: {
      el: '.testimonial-pagination',
      type: 'bullets',
      clickable: 'true',
      bulletElement: 'button',
    },
  }

  if ('autoplayDuration' in testimonialElement.dataset) {
    options.autoplay = {
      disableOnInteraction: true,
      delay: parseFloat(testimonialElement.dataset.autoplayDuration) * 1000,
    }
  }

  const swiper = new Swiper(`#${testimonialElement.dataset.swiperId}`, options)

  // Handle previous button
  function onPrevClick() {
    swiper.slideTo(swiper.activeIndex - 1)
  }
  const prevButton = testimonialElement.querySelector('.custom-button-prev')
  prevButton?.addEventListener('click', onPrevClick)

  // Handle next button
  function onNextClick() {
    swiper.slideTo(swiper.activeIndex + 1)
  }
  const nextButton = testimonialElement.querySelector('.custom-button-next')
  nextButton?.addEventListener('click', onNextClick)

  const updateButtons = () => {
    prevButton.disabled = swiper.isBeginning
    nextButton.disabled = swiper.isEnd
  }

  updateButtons()
  swiper.on('slideChange', updateButtons)
  swiper.on('reachBeginning', updateButtons)
  swiper.on('reachEnd', updateButtons)
  swiper.on('resize', updateButtons)

  // Handle button wrapper
  const buttonWrapper = testimonialElement.querySelector('.button-wrapper')
  const updateButtonWrapper = () => {
    buttonWrapper.classList.toggle('is-hidden', swiper.isLocked)
  }

  updateButtonWrapper()
  swiper.on('lock', updateButtonWrapper)
  swiper.on('unlock', updateButtonWrapper)

  return () => {
    swiper.destroy()
  }
})
